import { barcodeHTML, createCombinedBarcodeHTML } from "../template";
import { barcodeConfigManager } from "../config/barcode";
import { toast } from "react-toastify";
import { electronService } from "@/services/electronService";
import { selectPrinter } from "./BarcodePrinterPopup";
type Arguments = {
    mrp: number;
    sellingPrice: number;
    productName: string;
    barcode: string;
    slug: string;
    storeName: string;
    productCode: string;
    quantity?: number; 
}
export async function handlePrintBarcode(args:Arguments) {
    try {
        const barcodeContent = await barcodeHTML(args);
        const title = `Barcode-${args.productCode}`;
        
        if (electronService.isElectron()) {
            const config = barcodeConfigManager.getConfig();
            // Total paper width = (sticker width × columns) + (gap × (columns - 1)) + page margins
            const totalWidth = (config.width * config.stickersPerRow) + (config.stickerGap * (config.stickersPerRow - 1)) + (2 * config.pageMargin);
            // Total paper height = (sticker height × rows) + (rowGap × (rows - 1)) + page margins
            const totalHeight = (config.height * config.rowsPerPage) + (config.rowGap * Math.max(0, config.rowsPerPage - 1)) + (2 * config.pageMargin);
            const customPageSize = {
                width: totalWidth,
                height: totalHeight,
            };
            const selection = await selectPrinter(Math.max(1, args.quantity || 1));
            if (!selection) {
                return; // User cancelled
            }
            const { printerName, copies } = selection;
            
            const numCopies = Math.max(1, copies || 1);
            const arr = Array(numCopies).fill(args);
            const htmlToPrint = await createCombinedBarcodeHTML(arr);

            const res = await electronService.printReceipt(htmlToPrint, title, undefined, printerName, customPageSize);
            if (res && res.success) {
                toast.success(res.message || "Barcode printed successfully");
            } else {
                toast.error(res?.message || "Failed to print barcode");
            }
        } else {
            const printWindow = window.open("", "_blank", "width=800,height=600");
            if (printWindow) {
                printWindow.document.write(barcodeContent);
                printWindow.document.close();
                printWindow.focus();
                printWindow.onload = () => {
                    setTimeout(() => {
                        printWindow.print();
                        printWindow.close();
                    }, 500);
                };
                setTimeout(() => {
                    if (!printWindow.closed) {
                        printWindow.print();
                        printWindow.close();
                    }
                }, 1000);
            }
        }
    } catch (error: any) {
        toast.error(error?.message ?? "Something went wrong")
    }
}
export async function handlePrintMultipleBarcode(argsArray: Arguments[]) {
  try {
    if (!argsArray || argsArray.length === 0) {
      toast.error("No barcode data provided");
      return;
    }

    const allBarcodes: Arguments[] = [];
    argsArray.forEach(args => {
      const quantity = args.quantity || 1;
      for (let i = 0; i < quantity; i++) {
        const { quantity: _, ...barcodeArgs } = args;
        allBarcodes.push(barcodeArgs);
      }
    });

    const combinedHTML = await createCombinedBarcodeHTML(allBarcodes);
    const title = "Multiple-Barcodes";

    if (electronService.isElectron()) {
      const config = barcodeConfigManager.getConfig();
      // Total paper width = (sticker width × columns) + (gap × (columns - 1)) + page margins
      const totalWidth = (config.width * config.stickersPerRow) + (config.stickerGap * (config.stickersPerRow - 1)) + (2 * config.pageMargin);
      // Total paper height = (sticker height × rows) + (rowGap × (rows - 1)) + page margins
      const totalHeight = (config.height * config.rowsPerPage) + (config.rowGap * Math.max(0, config.rowsPerPage - 1)) + (2 * config.pageMargin);
      const customPageSize = {
        width: totalWidth,
        height: totalHeight,
      };
      const selection = await selectPrinter(); // No quantity input for multiple barcodes
      if (!selection) {
          return; // User cancelled
      }
      const { printerName } = selection;
      const res = await electronService.printReceipt(combinedHTML, title, undefined, printerName, customPageSize);
      if (res && res.success) {
          toast.success(res.message || "Barcodes printed successfully");
      } else {
          toast.error(res?.message || "Failed to print barcodes");
      }
    } else {
      const printWindow = window.open("", "_blank", "width=800,height=600");
      if (!printWindow) {
        toast.error("Please allow pop-ups for printing");
        return;
      }
      
      printWindow.document.write(combinedHTML);
      printWindow.document.close();
      printWindow.focus();
      
      setTimeout(() => {
        try {
          printWindow.print();
        } catch (printError) {
          console.error("Print failed:", printError);
          toast.error("Printing failed. Please try again.");
        }
        
        setTimeout(() => {
          if (printWindow && !printWindow.closed) {
            printWindow.close();
          }
        }, 1000);
      }, 1000);
    }

  } catch (error: any) {
    console.error("Barcode printing error:", error);
    toast.error(error?.message ?? "Failed to print barcodes");
  }
}